/*
 * @Date: 2019-08-22 11:57:24
 * @LastEditors: x
 * @LastEditTime: 2023-06-07 14:04:19
 */
import installApi from '../../api/install'

const actions = {
  getSigningState() {
    return installApi.getSigningState()
  },
  sendBindDevice(context , udid) {
    return installApi.sendBindDevice(udid)
  },
  /**
   * @description: 备注服务端在配置文件拿取值
   * @param {*}
   * @return {*}
   */  
  getAppdownloadlink() {
    return installApi.getAppdownloadlink()
  }
}

export default {
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/install.js